/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditsspendorder2Inputs */

const en_creditsspendorder2 = /** @type {(inputs: Creditsspendorder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spending uses this month’s credits first, then cashback, then extra credits. Unused monthly credits lapse. A higher plan tops up right away, a lower one from next month.`)
};

const de_creditsspendorder2 = /** @type {(inputs: Creditsspendorder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Einsatz gehen zuerst die Monats-Credits weg, dann das Cashback, dann die Extra-Credits. Nicht genutzte Monats-Credits verfallen. Bei einem höheren Plan wird sofort aufgefüllt, bei einem niedrigeren erst im nächsten Monat.`)
};

/**
* | output |
* | --- |
* | "Spending uses this month’s credits first, then cashback, then extra credits. Unused monthly credits lapse. A higher plan tops up right away, a lower one from..." |
*
* @param {Creditsspendorder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditsspendorder2 = /** @type {((inputs?: Creditsspendorder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditsspendorder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditsspendorder2(inputs)
	return de_creditsspendorder2(inputs)
});
export { creditsspendorder2 as "creditsSpendOrder" }